module.exports = __webpack_public_path__ + "img/expenses.344eac5f.svg";